import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem, FormWrapperInputComponent,
} from "../../../../common/component/Index";
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../../constants/Define";
import { isEqual, get, cloneDeep, groupBy } from 'lodash';
import * as Func from '../../../../../../helpers/functions';
import TagGroupDetail from '../../../../../../models/TagGroupDetail';
import Wrapper from './../../../../common/component/Wrapper';

import './TagGroupDetailItem.less';
import Input from "../../../../common/component/Input";
import { checkUndefine } from "../../../../../../helpers/functions";
import TranslateButton from '../../../../common/component/TranslateButton';
import DEFINE from '../../../../../../constants/Define';
import TagItem from '../../../../common/component/TagItem';
import ColorPicker from '../../../../common/component/ColorPicker';
import { Statistic } from 'antd';
import classNames from 'classnames'
import AntSelect, { AntOption, AntOptGroup } from '../../../../common/component/AntSelect';
import Button from '../../../../common/component/Button';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';
import UploadImage from '../../../../common/component/UploadImage';
import ApiService from 'api/ApiService';
import Config from 'constants/Config';
import Urls from 'api/Urls';

let permisionActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    validation: {},
};

export default class TagGroupDetailItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            tagGroupDetail: this.props.tagGroupDetailState.detail.tagGroupDetail,
            uploadFiles: [],
            isUploadingIcon: false,
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TAG_GROUP_DETAIL);
        this.initDetail()
    }

    initDetail() {
        const { match, tagGroupDetailState, tagGroupState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getTagGroupDetailItem(id);
        }
        if (!tagGroupState.allTagGroups.length) {
            this.props.getAllTagGroup();
        }
    }

    componentWillUnmount() {
        this.props.setTagGroupDetailItem(new TagGroupDetail())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tagGroupDetailState.detail.tagGroupDetail && !isEqual(nextProps.tagGroupDetailState.detail.tagGroupDetail, this.props.tagGroupDetailState.detail.tagGroupDetail)) {
            this.setState({ tagGroupDetail: nextProps.tagGroupDetailState.detail.tagGroupDetail, action: nextProps.tagGroupDetailState.detail.tagGroupDetail.id ? 'UPDATE' : this.state.action });
        }
    }

    render() {
        const { t, uploadState, tagGroupDetailState, tagGroupState } = this.props;
        const { isFetchingDetail } = tagGroupDetailState;
        const { action, isSubmit, isGetItem, validation, tagGroupDetail, isUploadingIcon } = this.state;
        return (
            <LoadingComponent spinning={isFetchingDetail}>
                <PageListComponent className="taggroupdetail-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'categories'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.tagGroupDetails.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.tagGroupDetails.title')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={tagGroupDetail.translations}
                                current={tagGroupDetail.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChange('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        onChangeActive={e => this.onChange(e.name, e.value)}
                        submitButtonRight={permisionActions && (permisionActions.allowCreate || permisionActions.allowUpdate)}
                        titleActiveComponent={tagGroupDetail.isActive ? t(`item.tagGroupDetails.active`) : t(`item.tagGroupDetails.deactive`)}
                        statusActive={tagGroupDetail.isActive}
                        statusActiveName={`isActive`}
                        activeComponent={'Switch'}
                        showActiveComponent={true}
                        additionalButton={this.renderAdditionalButtons()}
                    >
                        <Wrapper className='w-100'>
                            <FormWrapperItem>
                                <Wrapper className="col-md-4">
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.tagGroupDetails.review`)}
                                    >
                                        <Wrapper className="w-100">
                                            <TagItem
                                                className=""
                                                label={tagGroupDetail.name || t(`item.tagGroupDetails.name`)}
                                                color={tagGroupDetail.color}
                                                backgroundColor={tagGroupDetail.bgColor}
                                            />
                                        </Wrapper>
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-5">
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={tagGroupDetail.name}
                                        validation={validation.name}
                                        labelTitle={t(`item.tagGroupDetails.name`)}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                            value={checkUndefine(tagGroupDetail.name)} />
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-3">
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={tagGroupDetail.tagGroupId}
                                        validation={validation.tagGroupId}
                                        labelTitle={t(`item.tagGroupDetails.tagGroupId`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <AntSelect className="select-departure"
                                            showArrow showSearch
                                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tagGroupDetails.tagGroup")).toLowerCase())}
                                            value={tagGroupDetail.tagGroupId}
                                            onChange={value => this.onChange('tagGroupId', value)}
                                            style={{ width: '100%' }}
                                            filterOption={this.selectFilterSearch}
                                        >
                                            {this.renderAllTagGroup()}
                                        </AntSelect>
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-3">
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.tagGroupDetails.color`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Wrapper className="w-100">
                                            <input type="color" value={tagGroupDetail.color} onChange={e => this.onChange('color', e.target.value)} />
                                            {/* <ColorPicker
                                                className="p-2"
                                                color={tagGroupDetail.color}
                                                onChangeComplete={color => this.onChange('color', color.hex)}
                                            /> */}
                                        </Wrapper>
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-3">
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.tagGroupDetails.bgColor`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Wrapper className="w-100">
                                            <input type="color" value={tagGroupDetail.bgColor} onChange={e => this.onChange('bgColor', e.target.value)} />
                                            {/* <ColorPicker
                                                className="p-2"
                                                color={tagGroupDetail.bgColor}
                                                onChangeComplete={color => this.onChange('bgColor', color.hex)}
                                            /> */}
                                        </Wrapper>
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-3">
                                    <Wrapper
                                        className={classNames("w-100", {
                                            'form-input-visible-hide-backdrop': action === DETAIL_ACTIONS.TRANSLATE,
                                        })}
                                    >
                                        <Statistic
                                            title={t(`item.tagGroupDetails.linkedSkus`)}
                                            value={tagGroupDetail.tagGroupDetailSkus ? tagGroupDetail.tagGroupDetailSkus.length : 0} />
                                    </Wrapper>
                                </Wrapper>
                                <Wrapper className="col-md-3">
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.tagGroupDetails.order`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input placeholder="" type={`number`}
                                            className={`form-control`}
                                            name={`order`} onChange={(e) => this.onChange('order', e.target.value)}
                                            value={tagGroupDetail.order} />
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-3">
                                    <FormWrapperInputComponent
                                        labelTitle={'Icon'}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <UploadImage
                                            multiple={false}
                                            loading={isUploadingIcon}
                                            thumbnailSize="100%"
                                            buttonSize={80}
                                            thumbnailStyle={{ maxHeight: 80 }}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadIcon}
                                            onRemoveThumbnail={this.removeIcon}
                                            thumbnails={
                                                tagGroupDetail.icon
                                                    ? this.getThumbSources([tagGroupDetail.icon])
                                                    : undefined
                                            }
                                        />
                                    </FormWrapperInputComponent>
                                </Wrapper>
                            </FormWrapperItem>
                            {(action === DETAIL_ACTIONS.UPDATE) && (
                                <AutoTranslate
                                    className="wrapper-full"
                                    languageCode={tagGroupDetail?.languageCode || 'vi-VN'}
                                    onChange={this.onChange}
                                    targetLanguage={tagGroupDetail?.targetLanguage}
                                />
                            )}
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    renderAdditionalButtons() {
        const { action } = this.state;

        return (
            <Wrapper className="footer-manage-buttons">
                {action !== DETAIL_ACTIONS.TRANSLATE &&
                    <Fragment>
                        <Button
                            className="btn mr-2"
                            icon="bars"
                            disabled={this.state.action === DETAIL_ACTIONS.CREATE}
                            onClick={this.onClickLinkSku}>{this.props.t(`item.tagGroupDetails.linkSkus`)}</Button>
                    </Fragment>
                }
            </Wrapper>
        )
    }

    renderAllTagGroup() {
        const { t, tagGroupState } = this.props;
        const groupedData = groupBy(tagGroupState.allTagGroups, 'type');
        return Object.keys(groupedData).map(tagGroupTypeId => (
            <AntOptGroup key={tagGroupTypeId} label={t(`item.tagGroupDetails.tagGroupTypes.${tagGroupTypeId}`)}>
                {groupedData[tagGroupTypeId].map(item => (
                    <AntOption key={item.id} value={item.id}>{item.name}</AntOption>
                ))}
            </AntOptGroup>
        ))
    }

    onChange = (fieldName, value) => {
        const tagGroupDetail = this.state.tagGroupDetail;
        tagGroupDetail[fieldName] = typeof value === 'string' ? value.trimLeft() : value;
        this.setState({ tagGroupDetail });
    };

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.TAG_GROUP_DETAIL.LIST.path);
        }
    }

    onClickLinkSku = () => {
        const path = Func.getPathWithParams(PATHS.TAG_GROUP_DETAIL.DETAIL.LINK_SKU.path, { id: this.state.tagGroupDetail.id })
        this.props.history.push(path);
    }

    getThumbSources = (thumbs) => {
        return (thumbs || []).map(t => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t}`);
    }

    uploadIcon = (file) => {
        const selectedFile = file?.target?.files?.[0];
        if (!selectedFile) return;

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('directory', 'images');

        this.setState({ isUploadingIcon: true });

        new ApiService({
            baseURL: Config.API_CMS,
            endpoint: Urls.UPLOAD_STORAGE,
            parser: (data) => data.data,
            headers: {
                'Content-Type': undefined, 
            },
        })
            .post(formData)
            .then((res) => {
                const tagGroupDetail = cloneDeep(this.state.tagGroupDetail);
                tagGroupDetail.icon = res.fileUrl || res.fileUri;
                this.setState({ tagGroupDetail, isUploadingIcon: false });
            })
            .catch(() => {
                this.setState({ isUploadingIcon: false });
            });
    }

    removeIcon = () => {
        const tagGroupDetail = cloneDeep(this.state.tagGroupDetail);
        tagGroupDetail.icon = undefined;
        this.setState({ tagGroupDetail });
    }

    onShowTranslate = (language) => {
        const { tagGroupDetail } = this.state;
        tagGroupDetail.setTranslate(language.code);
        tagGroupDetail.setData();
        this.setState({ tagGroupDetail, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const tagGroupDetail = cloneDeep(this.state.tagGroupDetail);
        const action = DETAIL_ACTIONS[tagGroupDetail.id ? 'UPDATE' : 'CREATE'];
        tagGroupDetail.setTranslate(undefined, true);
        tagGroupDetail.setData();
        this.setState({ tagGroupDetail, action });
    }

    onSaveTranslate = () => {
        const { tagGroupDetail } = this.state;
        const translateFunction = tagGroupDetail.translate.id ? this.props.updateTagGroupDetailItemTranslate : this.props.createTagGroupDetailItemTranslate;
        translateFunction(tagGroupDetail, tagGroupDetail.languageCode);
        this.onExitTranslate();
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    onRemoveTranslate = (language) => {
        const { tagGroupDetail } = this.state;
        tagGroupDetail.setTranslate(language.code);
        this.props.deleteTagGroupDetailItemTranslate(tagGroupDetail, { id: tagGroupDetail.id });
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { tagGroupDetail, action } = this.state;
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createTagGroupDetailItem(tagGroupDetail)
            } else {
                this.props.updateTagGroupDetailItem(tagGroupDetail, {
                    onSuccess: () => this.props.getTagGroupDetailItem(tagGroupDetail.id)
                })
            }
        }
    };

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tagGroupDetails.name`)),
                tagGroupId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tagGroupDetails.tagGroup`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.tagGroupDetail, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
}
